import Image from 'next/image';
import { createClient } from '@sanity/client';
import getSanityUrl from './utils/getSanityUrl';

export const client = createClient({
  projectId: '6h446w2i', // you can find this in sanity.json
  dataset: 'production', // or the name you chose in step 1
  useCdn: true, // `false` if you want to ensure fresh data
  apiVersion: '2021-12-06'
  // serializers: {
  //   types: {
  //     album: (props) => (
  //       <Image
  //         width="1200"
  //         height="1200"
  //         src={getSanityUrl(props.node.asset).width(800).auto('format').url()}
  //         alt={props.node.alt}
  //       />
  //     ),
  //     inlineAlbum: (props) => (
  //       <figure>
  //         <Image
  //           width="1200"
  //           height="1200"
  //           src={getSanityUrl(props.node.asset).width(1200).auto('format').url()}
  //           alt={props.node.alt}
  //         />
  //       </figure>
  //     ),
  //     albumThumb: (props) => (
  //       <Image
  //         width="1200"
  //         height="1200"
  //         src={getSanityUrl(props.node.asset).width(250).auto('format').url()}
  //         alt={props.node.alt}
  //       />
  //     )
  //   }
  // }
});

export default client;
